module.exports = __webpack_public_path__ + "static/media/[棒棒糖]@2x.6a830693.png";